/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState, useCallback } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";
import getCroppedImg from "../../utils/cropImage";
import { CropperWrapper } from "../../utils/CropperWrapper";
import ImageUploader from "../../utils/ImageUploader";

// WZ126 — KD463002WHITE 190x253
// Pozycje tekstów (style inline, w mm):
//   top   = górna krawędź pola tekstowego
//   left  = środek tekstu (textAlign center + translateX(-50%)) albo lewa krawędź (textAlign left)
//   right = prawa krawędź pola (textAlign right)
// maxWidthN = maks. szerokość tekstu w px — dłuższy tekst zmniejsza czcionkę.
// Uwaga: lineHeight w stylu InlineEdit nie działa (nadpisuje go `font: inherit`), zawsze wynosi 1.5.
export const Wz126: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("czwartek");
  const [text2, setText2] = useState<string>("00:26");
  const [text3, setText3] = useState<string>("7");
  const [text4, setText4] = useState<string>("stycznia");
  const [text5, setText5] = useState<string>("2021");
  const [text6, setText6] = useState<string>("OSKAR");
  const [text7, setText7] = useState<string>("55");
  const [text8, setText8] = useState<string>("3600");
  const [text9, setText9] = useState<string>("g");
  const [text10, setText10] = useState<string>("cm");
  const text1BasicSize = 14;
  const text2BasicSize = 34;
  const text3BasicSize = 52;
  const text4BasicSize = 12;
  const text5BasicSize = 12;
  const text6BasicSize = 70;
  const text7BasicSize = 39;
  const text8BasicSize = 35;
  const text9BasicSize = 27;
  const text10BasicSize = 23;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const [fontSizeText7, setFontSizeText7] = useState<number>(text7BasicSize);
  const [fontSizeText8, setFontSizeText8] = useState<number>(text8BasicSize);
  const [fontSizeText9, setFontSizeText9] = useState<number>(text9BasicSize);
  const [fontSizeText10, setFontSizeText10] = useState<number>(text10BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();
  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "190mm"; // PDF width in mm
  const pdfHeight = "253mm"; // PDF height in mm
  const font1 = "JustSayin";
  const font2 = "MaritimeTropicalNeue";
  const maxWidth1 = 136;
  const maxWidth2 = 156;
  const maxWidth3 = 100;
  const maxWidth4 = 125;
  const maxWidth5 = 98;
  const maxWidth6 = 285;
  const maxWidth7 = 119;
  const maxWidth8 = 84;
  const maxWidth9 = 23;
  const maxWidth10 = 106;
  // Okno na zdjęcie użytkownika
  const photoTop = "35.9mm";
  const photoLeft = "43.4mm";
  const photoWidth = "103.7mm";
  const photoHeight = "100.9mm";
  const photoAspect = 103.7 / 100.9;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
    fontFamily: string,
    maxWidth: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px ${fontFamily}`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Czekamy na załadowanie fontu, inaczej canvas mierzy tekst fontem zastępczym.
  const ensureFont = (fontFamily: string) => document.fonts.load(`1em ${fontFamily}`);

  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 10, font1, maxWidth1))
    );
  }, [text1]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 10, font1, maxWidth2))
    );
  }, [text2]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 14, font1, maxWidth3))
    );
  }, [text3]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 10, font1, maxWidth4))
    );
  }, [text4]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText5(adjustFontSize(text5, fontSizeText5, text5BasicSize, 10, font1, maxWidth5))
    );
  }, [text5]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText6(adjustFontSize(text6, fontSizeText6, text6BasicSize, 14, font2, maxWidth6))
    );
  }, [text6]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText7(adjustFontSize(text7, fontSizeText7, text7BasicSize, 10, font1, maxWidth7))
    );
  }, [text7]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText8(adjustFontSize(text8, fontSizeText8, text8BasicSize, 10, font1, maxWidth8))
    );
  }, [text8]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText9(adjustFontSize(text9, fontSizeText9, text9BasicSize, 10, font1, maxWidth9))
    );
  }, [text9]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText10(adjustFontSize(text10, fontSizeText10, text10BasicSize, 10, font1, maxWidth10))
    );
  }, [text10]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };

  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      const croppedImg = await getCroppedImg(image, croppedAreaPixels);
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
        <ImageUploader
          onImageChange={(image) => setImage(image)}
          setStep={setStep}
        />
        {step === "crop" && (
          <p>
            Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
          </p>
        )}
        <div style={{}}>
          {step !== "crop" && (
            <Button onClick={handleSave} disabled={isSaving}>
              {isSaving ? "Zapisywanie..." : "Zapisz"}
            </Button>
          )}
          {step === "crop" && (
            <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
          )}
        </div>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "JustSayin, MaritimeTropicalNeue",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        {/* czwartek */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: font1,
            color: "#fefaf7",
            position: "absolute",
            top: "135.9mm",
            left: "36.8mm",
            width: `${maxWidth1 + 10}px`,
            transform: "translateX(-50%) rotate(-9.4deg)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "-0.2px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 00:26 */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "140.9mm",
            left: "152.7mm",
            width: `${maxWidth2 + 10}px`,
            transform: "translateX(-50%) rotate(9.4deg)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "0.4px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 7 */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: font1,
            color: "#fefaf7",
            position: "absolute",
            top: "137.2mm",
            left: "38.2mm",
            width: `${maxWidth3 + 10}px`,
            transform: "translateX(-50%) rotate(-9.1deg)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* stycznia */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: font1,
            color: "#fefaf7",
            position: "absolute",
            top: "154.9mm",
            left: "40.3mm",
            width: `${maxWidth4 + 10}px`,
            transform: "translateX(-50%) rotate(-9.4deg)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 2021 */}
        <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: font1,
            color: "#fefaf7",
            position: "absolute",
            top: "158.8mm",
            left: "40.7mm",
            width: `${maxWidth5 + 10}px`,
            transform: "translateX(-50%) rotate(-9.4deg)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* OSKAR */}
        <InlineEdit
          value={text6}
          setValue={setText6}
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: font2,
            color: "#2b2a29",
            position: "absolute",
            top: "144.5mm",
            left: "95.3mm",
            width: `${maxWidth6 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "4.0px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 55 */}
        <InlineEdit
          value={text7}
          setValue={setText7}
          style={{
            fontSize: `${fontSizeText7}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "189.2mm",
            left: "79.6mm",
            width: `${maxWidth7 + 10}px`,
            transform: "translateX(-50%) rotate(-1.6deg)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "1.0px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 3600 */}
        <InlineEdit
          value={text8}
          setValue={setText8}
          style={{
            fontSize: `${fontSizeText8}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "192.3mm",
            left: "122.7mm",
            width: `${maxWidth8 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* g */}
        <InlineEdit
          value={text9}
          setValue={setText9}
          style={{
            fontSize: `${fontSizeText9}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "195.3mm",
            left: "137.2mm",
            width: `${maxWidth9 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* cm */}
        <InlineEdit
          value={text10}
          setValue={setText10}
          style={{
            fontSize: `${fontSizeText10}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "203.3mm",
            left: "78.6mm",
            width: `${maxWidth10 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "1.8px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />

        {/* Step: Crop */}
        {image && step === "crop" && (
          <CropperWrapper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={photoAspect}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
            style={{
              top: photoTop,
              left: photoLeft,
              width: photoWidth,
              height: photoHeight,
              transform: "none",
            }}
          />
        )}

        {/* Step: View */}
        {croppedImage && step === "view" && (
          <img
            src={croppedImage}
            alt=""
            style={{
              position: "absolute",
              top: photoTop,
              left: photoLeft,
              width: photoWidth,
              height: photoHeight,
              objectFit: "cover",
              clipPath: "polygon(99.87% 49.62%, 99.75% 53.30%, 99.38% 56.94%, 98.86% 60.58%, 98.28% 64.22%, 97.55% 67.88%, 96.74% 71.57%, 95.92% 75.38%, 94.65% 79.08%, 93.12% 82.70%, 90.72% 85.74%, 87.78% 88.22%, 84.58% 90.33%, 81.53% 92.47%, 78.25% 94.20%, 74.91% 95.67%, 71.59% 97.05%, 68.18% 98.08%, 64.76% 98.95%, 61.32% 99.56%, 57.88% 99.91%, 54.45% 100.00%, 51.05% 99.85%, 47.68% 99.55%, 44.37% 99.01%, 41.14% 98.12%, 37.97% 97.12%, 34.91% 95.90%, 31.92% 94.54%, 28.95% 93.17%, 26.08% 91.58%, 23.32% 89.79%, 20.69% 87.80%, 18.13% 85.71%, 15.66% 83.49%, 13.39% 81.02%, 11.22% 78.45%, 8.89% 75.94%, 6.88% 73.13%, 4.97% 70.19%, 3.34% 67.05%, 2.01% 63.76%, 1.08% 60.31%, 0.39% 56.79%, 0.02% 53.21%, 0.00% 49.62%, 0.12% 46.04%, 0.48% 42.47%, 0.98% 38.92%, 1.82% 35.44%, 2.71% 31.96%, 3.83% 28.53%, 5.10% 25.14%, 6.60% 21.83%, 8.42% 18.67%, 10.36% 15.58%, 12.81% 12.90%, 15.62% 10.63%, 18.43% 8.44%, 21.55% 6.71%, 24.68% 5.15%, 27.85% 3.73%, 31.20% 2.84%, 34.44% 1.83%, 37.77% 1.25%, 41.06% 0.62%, 44.37% 0.24%, 47.69% 0.00%, 51.03% 0.00%, 54.35% 0.14%, 57.70% 0.43%, 61.04% 0.86%, 64.41% 1.44%, 67.77% 2.19%, 71.20% 3.01%, 74.57% 4.19%, 77.93% 5.55%, 81.17% 7.25%, 84.32% 9.22%, 87.43% 11.37%, 90.35% 13.84%, 92.95% 16.66%, 95.31% 19.75%, 97.19% 23.16%, 98.32% 26.94%, 99.18% 30.76%, 99.68% 34.61%, 100.00% 38.43%, 99.95% 42.22%, 99.94% 45.94%)",
              zIndex: 1,
            }}
          />
        )}

        <img
          src="/images/KD463002_WZ126.svg"
          alt=""
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};
